import React from 'react';
import Header from './Global/Header';
import Footer from './Global/Footer';
import {Link} from "react-router-dom";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

function Collectibles(){
    return(
        <>
        <Header />
        <main className="main">
                <div className="container">
            <div className="row row--grid">
            <div className="col-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb__item"><Link to="/">Home</Link> <span> /</span></li>
                                <li className="breadcrumb__item breadcrumb__item--active">Collectibles</li>
                            </ul>
                        </div>
                <div className="col-12 col-sm-12 col-lg-12 col-xl-12"> 
                    <div className="card">
                        <div className="row row--grid" style={{width:"100%",margin:"0"}}>
                            <div className="collect_img_div col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                                <img src={"../images/cover1.jpg"} alt=""></img>
                            </div>
                            <div className="collect_text_div col-xl-9 col-lg-9 col-md-8 col-sm-12 col-xs-12">
                                <h4>Walking on Air</h4>
                                <h6>@nickname</h6>
                                <AudioPlayer
                                    src={"../audio.MP3"}
                                    onPlay={e => console.log("onPlay")}
                                    // other props here
                                />
                                <div class="card__info">
                                    <div class="card__price">
                                        <span>Reserve price</span>
                                        <span>4.89 ETH</span>
                                    </div>
                                    
                                    <button class="card__likes" type="button">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z"/></svg>
                                        <span>189</span>
                                    </button>
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-lg-12 col-xl-12"> 
                    <div className="card">
                        <div className="row row--grid" style={{width:"100%",margin:"0"}}>
                            <div className="collect_img_div col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                                <img src={"../images/cover2.jpg"} alt=""></img>
                            </div>
                            <div className="collect_text_div col-xl-9 col-lg-9 col-md-8 col-sm-12 col-xs-12">
                                <h4>To Infinity And Beyond</h4>
                                <h6>@johndoe</h6>
                                <AudioPlayer
                                    src={"../audio.MP3"}
                                    onPlay={e => console.log("onPlay")}
                                    // other props here
                                />
                                <div class="card__info">
                                    <div class="card__price">
                                        <span>Reserve price</span>
                                        <span>5.04 ETH</span>
                                    </div>
                                    
                                    <button class="card__likes" type="button">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z"/></svg>
                                        <span>179</span>
                                    </button>
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-lg-12 col-xl-12"> 
                    <div className="card">
                        <div className="row row--grid" style={{width:"100%",margin:"0"}}>
                            <div className="collect_img_div col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                                <img src={"../images/cover3.jpg"} alt=""></img>
                            </div>
                            <div className="collect_text_div col-xl-9 col-lg-9 col-md-8 col-sm-12 col-xs-12">
                                <h4>Les Immortels, the Treachery of Artificial Shadows</h4>
                                <h6>@neo</h6>
                                <AudioPlayer
                                    src={"../audio.MP3"}
                                    onPlay={e => console.log("onPlay")}
                                    // other props here
                                />
                                <div class="card__info">
                                    <div class="card__price">
                                        <span>Reserve price</span>
                                        <span>2.61 ETH</span>
                                    </div>
                                    
                                    <button class="card__likes" type="button">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z"/></svg>
                                        <span>200</span>
                                    </button>
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-lg-12 col-xl-12"> 
                    <div className="card">
                        <div className="row row--grid" style={{width:"100%",margin:"0"}}>
                            <div className="collect_img_div col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12">
                                <img src={"../images/cover4.jpg"} alt=""></img>
                            </div>
                            <div className="collect_text_div col-xl-9 col-lg-9 col-md-8 col-sm-12 col-xs-12">
                                <h4>Flowers in Concrete (Modal)</h4>
                                <h6>@min1max</h6>
                                <AudioPlayer
                                    src={"../audio.MP3"}
                                    onPlay={e => console.log("onPlay")}
                                    // other props here
                                />
                                <div class="card__info">
                                    <div class="card__price">
                                        <span>Reserve price</span>
                                        <span>3.19 ETH</span>
                                    </div>
                                    
                                    <button class="card__likes" type="button">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z"/></svg>
                                        <span>150</span>
                                    </button>
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>
            </div>
           
			<div className="row row--grid">
				<div className="col-12">
					<div className="paginator">
						<span className="paginator__pages">8 from 169</span>

						<ul className="paginator__list">
							<li>
								<a href="/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"/></svg></a>
							</li>
							<li className="active"><a href="/">1</a></li>
							<li><a href="/">2</a></li>
							<li><a href="/">3</a></li>
							<li><a href="/">4</a></li>
							<li>
								<a href="/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.92,11.62a1,1,0,0,0-.21-.33l-5-5a1,1,0,0,0-1.42,1.42L14.59,11H7a1,1,0,0,0,0,2h7.59l-3.3,3.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5-5a1,1,0,0,0,.21-.33A1,1,0,0,0,17.92,11.62Z"/></svg></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
        </div>
        </main>
        <Footer />
        </>
    );
}

export default Collectibles;
